import axios from "axios";

import { API_BASE_URL } from "../../utils/constants";

export const fetchFileDetailRequest = (email, code, GUID) => {
    return new Promise((resolve, reject) => {
        const language = localStorage.getItem("i18nextLng");
        axios
            .get(`${API_BASE_URL}/external/file/${GUID}/`, {
                headers: {
                    "Accept-Language": language || "es",
                    "Verification-Code": code,
                    "External-User-Email": email,
                },
            })
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
};

export const fetchWorkflowInformationRequest = (email, code, GUID) => {
    return new Promise((resolve, reject) => {
        const language = localStorage.getItem("i18nextLng");
        axios
            .get(`${API_BASE_URL}/external/file/${GUID}/workflow/`, {
                headers: {
                    "Accept-Language": language || "es",
                    "Verification-Code": code,
                    "External-User-Email": email,
                },
            })
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
};

export const shareFileRequest = (email, code, GUID, data) => {
    return new Promise((resolve, reject) => {
        const language = localStorage.getItem("i18nextLng");
        axios
            .post(`${API_BASE_URL}/external/file/${GUID}/share/`, data, {
                headers: {
                    "Accept-Language": language || "es",
                    "Verification-Code": code,
                    "External-User-Email": email,
                },
            })
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
};

export const downloadFileRequest = (email, code, data) => {
    return new Promise((resolve, reject) => {
        const language = localStorage.getItem("i18nextLng");
        axios
            .post(`${API_BASE_URL}/external/file/download/`, data, {
                headers: {
                    "Accept-Language": language || "es",
                    "Verification-Code": code,
                    "External-User-Email": email,
                },
            })
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
};
